class Sedes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mapOptions: {
        center: {
          lat: 4.6489681,
          lng: -74.1325349
        },
        zoom: 12
      },
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      areaOptions: [],
      areaSelected: "Todas",
      locations: [],
      showMap: false,
      areas: []
    };
    this.map = undefined;
    this.currentLatLng = undefined;
    this.infowindow = undefined;
    this.markers = [];
    this.directionsDisplay = undefined;
    this.googleChecker = this.googleChecker.bind(this);
    this.renderMap = this.renderMap.bind(this);
    this.renderInfoWindow = this.renderInfoWindow.bind(this);
    this.filterLocationsByArea = this.filterLocationsByArea.bind(this);
    this.openLocationFromList = this.openLocationFromList.bind(this);
  }

  componentDidMount() {
    this.googleChecker();
  }

  googleChecker() {
    /*  if(!window.google || !window.google.maps) {
      setTimeout(this.googleChecker, 200);
    } else { */
    this.getAreas(areas => {
      const areaOptions = [];
      areas.forEach(area => {
        if (areaOptions.indexOf(area.name) == -1) areaOptions.push(area.name);
      });
      this.setState({ areaOptions, areas }, () => {
        this.getLocations(null, locations => {
          this.setState({ locations });
          //this.renderMap(locations);
        });
      });
    });
    //}
  }

  getAreas(successCallback) {
    const pnpService = new ServicioPnp();
    pnpService.getList(
      "sedesSalud",
      list => {
        let areas = list.map(item => {
          return {
            id: item.CSSaliRedCodigoSedeText,
            name: item.CSSaliRedZonaChoise
          };
        });
        successCallback(areas);
      },
      "CSSaliRedEstadoChoise eq 'Activo' and CSSaliRedServicioChoise eq '" +
        this.props.plan +
        "' or CSSaliRedServicioChoise eq 'MX'",
      "CSSaliRedCodigoSedeText",
      "CSSaliRedCodigoSedeSaludText",
      "CSSaliRedZonaChoise",
      "CSSaliRedServicioChoise"
    );
  }

  getLocations(areaFilter, successCallback) {
    let sedesFilter = [];
    if (areaFilter) {
      this.state.areas.forEach(area => {
        if (area.name == areaFilter)
          sedesFilter.push("CodigoSede eq " + area.id);
      });
    } else {
      sedesFilter = this.state.areas.map(area => {
        return "CodigoSede eq " + area.id;
      });
    }
    sedesFilter = sedesFilter.join(" or ");
    const pnpService = new ServicioPnp();
    pnpService.getList(
      "sedes",
      list => {
        const locations = list.map(location => {
          return {
            id: location.Id,
            code: location.CodigoSede,
            name: location.NombreSede,
            lat: location.Latitud,
            lng: location.Longitud,
            address: location.Direccion,
            phone: location.Telefono,
            schedule: location.Horario,
            parking: location.Parqueadero,
            url: location.TituloUrl
          };
        });
        successCallback(locations);
      },
      sedesFilter /*, 'CodigoSede', 'Direccion', 'Telefono', 'Latitud', 'Longitud', 'NombreSede', 'FileRef/Imagen', 'FieldValuesAsText/MetaInfo'*/
    );
  }

  filterLocationsByArea(area) {
    this.getLocations(area == "Todas" ? null : area, locations => {
      this.setState({ locations, areaSelected: area });
      this.renderMap(locations);
    });
  }

  renderInfoWindow(location) {
    const image = location.image;
    let srcWithQuotes = image.match(/src\=([^\s]*)\s/)[1];
    srcWithQuotes.substring(1, srcWithQuotes.length - 1);
    const locImage =
      '<img alt="" class="venue-image" src=' +
      srcWithQuotes +
      ' oncontextmenu="return false;" style="BORDER: 0px solid; ">';
    return (
      '<div class="info">' +
      image +
      '<div class="infosede">' +
      "<h3>" +
      location.name +
      "</h3>" +
      (location.phone ? '<p class="telefono">' + location.phone + "</p>" : "") +
      (location.address
        ? '<p class="pinUbicacion">' + location.address + "</p>"
        : "") +
      '<select id="how-to-arrive-select"><option value="">Cómo Llegar</option><option value="DRIVING">Vehículo particular</option><option value="TRANSIT">Transporte público</option><option value="WALKING">Caminando</option></select>' +
      (location.url
        ? '<a class="btn btn-primary" href="https://corporativo.compensar.com/sedes/' +
          location.url +
          '" target="_blank" >Más información</a>'
        : "") +
      '<br><a class="btn btn-primary' +
      (this.props.configurations["BotonMedicoPersonalLinkCSVisibleBool"]
        ? ""
        : " hidden") +
      '" href="' +
      this.props.configurations["BotonMedicoPersonalLink"] +
      '">Médico Personal</a>' +
      '<a class="cerrarCaja"></a>' +
      "</div>" +
      "</div>"
    );
  }

  openLocation(locationLatLng, marker) {
    this.infowindow.open(this.map, marker);
    this.map.setCenter(marker.getPosition());
    const howToArriveSelect = document.getElementById("how-to-arrive-select");
    const closeMarker = document.querySelector(".cerrarCaja");
    closeMarker.addEventListener("click", e => {
      this.infowindow.close();
    });
    this.map.panTo(marker.getPosition());
    howToArriveSelect.addEventListener("change", e => {
      if (howToArriveSelect.value) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.currentLatLng = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            this.infowindow.close();
            const directionsService = new google.maps.DirectionsService();
            this.directionsDisplay.setMap(this.map);
            directionsService.route(
              {
                origin: {
                  lat: this.currentLatLng.lat,
                  lng: this.currentLatLng.lng
                },
                destination: {
                  lat: locationLatLng.lat,
                  lng: locationLatLng.lng
                },
                travelMode: google.maps.TravelMode[e.target.value]
              },
              (response, status) => {
                if (status == "OK") {
                  this.directionsDisplay.setDirections(response);
                  this.directionsDisplay.setOptions({
                    polylineOptions: {
                      strokeWeight: 4,
                      strokeOpacity: 1,
                      strokeColor: "red"
                    }
                  });
                } else {
                  console.log("Directions request failed due to " + status);
                }
              }
            );
          },
          error => {
            console.log("The user did not allowed geolocation");
          }
        );
      }
    });
  }

  renderLocations(locations) {
    this.markers = [];
    locations.forEach(location => {
      let latLng = {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng)
      };
      let marker = new google.maps.Marker({
        position: latLng,
        map: this.map,
        animation: google.maps.Animation.DROP,
        title: location.name,
        location: location
      });
      this.markers.push(marker);
      marker.addListener("click", () => {
        this.map.panTo(marker.getPosition());
        const pnpService = new ServicioPnp();
        pnpService.getItemAsHtml(marker.location.id, "sedes", item => {
          marker.location.image = item.Imagen;
          this.infowindow.setContent(this.renderInfoWindow(marker.location));
          this.openLocation(latLng, marker);
        });
      });
    });
  }

  renderMap(locations) {
    this.map = new google.maps.Map(
      this.refs.mapContainer,
      this.state.mapOptions
    );
    this.directionsDisplay = new google.maps.DirectionsRenderer();

    this.infowindow = new google.maps.InfoWindow({
      maxWidth: 280
    });

    const geocoder = new google.maps.Geocoder();

    this.renderLocations(locations);
  }

  activeMap = e => {
    e.preventDefault();
    if (this.state.locations) {
      const showMap = true;
      this.setState({ showMap }, () => this.renderMap(this.state.locations));
    }
  };

  openLocationFromList(event, location) {
    const latLng = {
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lng)
    };
    const marker = this.markers.find(marker => {
      return marker.location.id == location.id;
    });
    const pnpService = new ServicioPnp();
    pnpService.getItemAsHtml(location.id, "sedes", item => {
      marker.location.image = item.Imagen;
      this.infowindow.setContent(this.renderInfoWindow(marker.location));
      this.openLocation(latLng, marker);
    });
  }

  render() {
    return (
      <div id="doctor-container" className="doctor-container">
        <div className="row">
          <div className="col-sm-12">
            <form
              className="form-horizontal"
              style={{
                padding: "20px 0",
                margin: "20px 0",
                borderTop: "1px solid #F2F2F2",
                borderBottom: "1px solid #F2F2F2"
              }}
            >
              <div className="form-group mb-0">
                <div className="col-sm-12">
                  {this.state.showMap ? (
                    <div>
                      Zona
                      <DropdownButton
                        title={this.state.areaSelected}
                        id="area"
                        className="dropdown-custom ml-10"
                        bsStyle="inline"
                        onSelect={value => this.filterLocationsByArea(value)}
                      >
                        <MenuItem
                          eventKey={"Todas"}
                          className={
                            this.state.areaSelected == "Todas" ? "active" : ""
                          }
                        >
                          Todas
                        </MenuItem>
                        {this.state.areaOptions.map(area => {
                          return (
                            <MenuItem
                              eventKey={area}
                              className={
                                this.state.areaSelected === area ? "active" : ""
                              }
                            >
                              {area}
                            </MenuItem>
                          );
                        })}
                      </DropdownButton>
                    </div>
                  ) : (
                    <div
                      id="map"
                      ref="mapContainer"
                      style={{ height: "500px" }}
                    >
                      <img
                        src={`${
                          _spPageContextInfo.siteAbsoluteUrl
                        }/PublishingImages/sedes/mapa-sedes-prev1.jpg`}
                        alt="Sedes de compensar"
                        onClick={this.activeMap}
                        style={{
                          height: "100%",
                          width: "100%",
                          "object-fit": "cover",
                          cursor: "pointer"
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.state.showMap ? (
          <div className="row">
            <div className="col-sm-3">
              <h3>Sedes asignadas</h3>
              <div style={{ overflowY: "scroll", height: "465px" }}>
                <ul className="locations-list">
                  {this.state.locations.map(location => {
                    return (
                      <li
                        onClick={event =>
                          this.openLocationFromList(event, location)
                        }
                      >
                        <strong>{location.name}</strong>
                        <br />
                        <i className="fa fa-map-marker" /> {location.address}
                        <br />
                        <i className="fa fa-phone" /> Teléfono {location.phone}
                        <br />
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-sm-9">
              <div id="map" ref="mapContainer" style={{ height: "500px" }} />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

/******************** BUILD ********************/
let DropdownButton = ReactBootstrap.DropdownButton;
let MenuItem = ReactBootstrap.MenuItem;
/******************** BUILD ********************/

export default Sedes;



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/sedesAtencion/src/components/sedes.js